<app-nav></app-nav>
<app-hero></app-hero>
<app-projects></app-projects>
<app-resume></app-resume>
<app-technologies></app-technologies>   
<app-footer></app-footer>